import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IBookAccessHistoryMetaVm } from '../book-access-history-meta-vm.model';
import { IPaginatedResultBookAccessHistoryMetaVm } from '../paginated-result-book-access-history-meta-vm.model';
import { SortOrder } from '../sort-order.model';
@Injectable({ providedIn: 'root' })
export class BookAccessHistoryService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/BookAccessHistory`;
  }
  get(sortColumn: string, page?: number, pageSize?: number, sortOrder?: SortOrder): Observable<IPaginatedResultBookAccessHistoryMetaVm> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (page !== undefined && page !== null) {
      params = params.set('page', page.toString());
    }
    if (pageSize !== undefined && pageSize !== null) {
      params = params.set('pageSize', pageSize.toString());
    }
    if (sortColumn !== undefined && sortColumn !== null) {
      params = params.set('sortColumn', sortColumn.toString());
    }
    if (sortOrder !== undefined && sortOrder !== null) {
      params = params.set('sortOrder', sortOrder.toString());
    }
    return this.http.get<IPaginatedResultBookAccessHistoryMetaVm>(this.baseUrl, { headers, params });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
